$(document).ready(function(){
    $(document).on('click touchend', '.accessibility-option', function(event){
        if (dragging) return;

        // get the type of option selected
        $type = $(this).data('type');

        // set default value based off the type
        $newValue = "default";

        // check if the person checked a non-default value
        if ($(this).prop('checked', true)) {
            $newValue = $(this).data('value');
        }

        // uncheck all boxes of the same data type
        $('.accessibility-option[data-type="' + $type + '"]').prop('checked', false);

        // set cookie
        Cookies.set($type, $newValue, { expires: 365 });

        // check the option that was clicked
        $(this).prop('checked', true);

        // set attribute on html tag for css
        $('html').attr('data-' + $type, $newValue);
    });
});